import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal } from 'antd';
import './BuyMessage.scss';

class BuySuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      status: true,
      affinityBtn1: null,
      affinityBtn2: null,
      title: '', // 标题
      message: '', // 描述
    };
  }

  // 展示
  showModal = (
    status = false,
    title = '购买失败',
    message = '购买失败，请稍候重试',
    affinityBtn1,
    affinityBtn2
  ) => {
    this.setState({
      visible: true,
      status,
      title,
      message,
      affinityBtn1,
      affinityBtn2,
    });
  };

  // 关闭
  hideModal = (e) => {
    e && e.preventDefault();

    this.setState({ visible: false });
  };

  render() {
    const { visible, status, title, message, affinityBtn1, affinityBtn2 } =
      this.state;
    return (
      <Modal
        open={visible}
        onCancel={this.hideModal}
        title="提示"
        width={400}
        footer={null}
        centered={true}
        keyboard={false}
        maskClosable={false}
        wrapClassName="daidai-modal-style has-top-border"
      >
        {status ? (
          <div className="props-mall-success">
            <i className="icon-success" />
            <p className="success-text">{title}</p>
            <p
              className="message"
              style={{
                paddingBottom: affinityBtn1 || affinityBtn2 ? 0 : '100px',
              }}
            >
              {message}
            </p>
            {affinityBtn1 || affinityBtn2 ? (
              <div className="affinity-action">
                {affinityBtn1 && affinityBtn1}
                {affinityBtn2 && affinityBtn2}
              </div>
            ) : null}
          </div>
        ) : (
          <div className="props-mall-error">
            <i className="icon-error" />
            <p className="error-text">{title}</p>
            <p className="message">{message}</p>
          </div>
        )}
      </Modal>
    );
  }
}

export default withRouter(BuySuccess, { withRef: true });
